import React from "react";
import { useGuidedTour } from "../GuidedTourProvider";
import { TOUR_ORDER, TOURS } from "../tours";
import { t } from "../i18n";
import styles from "./TourListSheet.module.scss";

const TourListSheet = () => {
  const { listOpen, closeList, startTour, progress } = useGuidedTour();

  if (!listOpen) return null;

  const renderStatus = (tourId) => {
    const p = progress[tourId];
    if (p?.completed) {
      return <span className={`${styles.badge} ${styles.badgeDone}`}>✓ {t("tours.list.status_completed")}</span>;
    }
    if ((p?.currentStep ?? 0) > 0) {
      return (
        <span className={`${styles.badge} ${styles.badgeProgress}`}>
          {t("tours.list.status_inProgress", { step: p.currentStep + 1 })}
        </span>
      );
    }
    return <span className={`${styles.badge} ${styles.badgePending}`}>{t("tours.list.status_pending")}</span>;
  };

  return (
    <div className={styles.backdrop} onClick={closeList}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <button className={styles.close} onClick={closeList} aria-label="Close">×</button>
        <div className={styles.header}>
          <div className={styles.memoji} role="img" aria-label="Guide">👩🏻‍💻</div>
          <h2 className={styles.title}>{t("tours.list.title")}</h2>
          <p className={styles.subtitle}>{t("tours.list.subtitle")}</p>
        </div>

        <div className={styles.list}>
          {TOUR_ORDER.map((id) => {
            const tour = TOURS[id];
            if (!tour) return null;
            const done = progress[id]?.completed;
            return (
              <button
                key={id}
                className={styles.row}
                onClick={() => startTour(id, 0)}
              >
                <span className={`${styles.playIcon} ${done ? styles.playIconDone : ""}`}>
                  {done ? "↻" : "▶"}
                </span>
                <div className={styles.rowBody}>
                  <div className={styles.rowTitle}>{t(tour.i18nTitle)}</div>
                  {renderStatus(id)}
                </div>
                <span className={styles.chevron}>›</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TourListSheet;
